import { render } from "./homeDataEmpty.vue?vue&type=template&id=50eea2c3&scoped=true"
import script from "./homeDataEmpty.vue?vue&type=script&lang=js"
export * from "./homeDataEmpty.vue?vue&type=script&lang=js"

import "./homeDataEmpty.vue?vue&type=style&index=0&id=50eea2c3&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50eea2c3"]])

export default __exports__